import wisIncentives from './wis-incentives';
import account from './account';
import vcdaError from './vcdaError';

const root = {
	wisIncentives,
	account,
	vcdaError
};

export default root;
